module.exports = __webpack_public_path__ + "static/media/294068.7489f5d7.png";